import React from 'react';
import s from './SocialLincs.module.css';
import { ImFacebook } from 'react-icons/im';
import { ImYoutube } from 'react-icons/im';
import { ImTwitter } from 'react-icons/im';
import { RiInstagramLine } from 'react-icons/ri';
import { IconContext } from 'react-icons';

// ;
// ;
// MdArrowForward;
// ;

export default function SocialLincs() {
  return (
    <div>
      <IconContext.Provider
        value={{ color: '#D8D8D8', className: 'global-class-name' }}
      >
        <ul className={s.list}>
          <li className={s.item}>
            <ImFacebook size="1.5rem" className={s.facebook} />
          </li>
          <li className={s.item}>
            <ImTwitter size="1.5rem" className={s.twitter} />
          </li>
          <li className={s.item}>
            <ImYoutube size="1.5rem" className={s.youtube} />
          </li>
          <li className={s.item}>
            <RiInstagramLine size="1.5rem" className={s.instagramm} />
          </li>
        </ul>
      </IconContext.Provider>
    </div>
  );
}
